import React, { Component, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Col, Row } from 'reactstrap';
import Avatar from '@mui/material/Avatar';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddGroup from '../../groups/addGroup'
import DialogContentText from '@mui/material/DialogContentText';
import { listGroup, addStaff, listPermissionModules } from 'actions/admin';
import { connect } from 'react-redux';
import ReactStrapTextField from '../../components/ReactStrapTextField/index';
import ReactstrapSelectField from '../../components/reactstrapSelectField/index';
import { Switch } from '@mui/material';
import { Field, Form } from 'react-final-form'
import { required, emailField, validatePhone } from '../../../../constants/validations';
import Axios from '../../../../sagas/axiosRequest';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import AppConfig from 'constants/config'
import { NotificationManager } from 'react-notifications';
import { FormGroup, Input } from 'reactstrap';
import { listStaff } from 'actions/admin';

function EditStaff(props) {
    const [state, setState] = useState({
        name: '',
        email: '',
        phone: '',
        groupId: '',
        permission: [],
        groups: [],
        addGroup: false,
        isAllPermission: false,
        isRM: false,
        isReportingManager: false,
        staffId: '',
        relationalManager2: '',
        configPopup: false,
        managerValue: ''
    })
    const [managerListed, setManagerListed] = useState([])

    const updateAllManagerData = async (isRelationManager, reporting_manager, isReportingManager) => {
        let Staff_id = props.selectedData._id
        let data = {
            Staff_id, isRM: isRelationManager, reporting_manager: reporting_manager, isReportingManager: isReportingManager
        }
        await axios.post(`${AppConfig.baseUrl}users/updateStaffManagers`, data, {
            headers: {
                'Content-Type': 'application/json',
                'token': localStorage.getItem('admin_token')
            },
        }).then(result => {
            console.log(result.data.title)
        })
    }

    const handleChangeManager = async (e) => {
        if (e.target.value !== '') {
            const updatedState = {
                ...state,
                isReportingManager: false,
                isRM: true,
                relationalManager2: e.target.value,
                configPopup: false
            };

            await setState(updatedState);
            await updateAllManagerData(updatedState.isRM, updatedState.relationalManager2, updatedState.isReportingManager)
            props.listStaff({ history: props.history, searchText: state.searchText, page: 1, perPage: 50 })
        }
    }

    const handleClosePopup = async () => {
        setState((prev) => ({
            ...prev,
            isRM: false,
            configPopup: false
        }));
    }

    const handleRMToggle = async (e) => {
        const checked = e.target.checked;
        await updateAllManagerData(state.isRM, state.relationalManager2, false)

        const updatedState = {
            ...state,
            isRM: checked,
            isReportingManager: checked ? false : state.isReportingManager,
            relationalManager2: null,
            configPopup: checked
        };
        await setState(updatedState);
        if (checked === false) {
            await updateAllManagerData(false, null, updatedState.isReportingManager)
        }
        await getList_Manager()
    };

    const handleRepoManagerToggle = async (e) => {
        const checked = e.target.checked;
        const updatedState = {
            ...state,
            isRM: checked ? false : state.isRM,
            isReportingManager: checked,
            relationalManager2: null
        };

        await setState(updatedState);
        await updateAllManagerData(updatedState.isRM, updatedState.relationalManager2, updatedState.isReportingManager)
        props.listStaff({ history: props.history, searchText: state.searchText, page: 1, perPage: 50 })
        await getList_Manager()
    };

    const handleChange1 = async (event, fieldName) => {
        const selectedValue = event.target.value;
        if (selectedValue === "Relational Manager") {
            setState((prev) => ({
                ...prev,
                isRM: true,
                isReportingManager: false,
                configPopup: true,
                managerValue: selectedValue,
            }));
            await getList_Manager()
        } else if (selectedValue === "Reporting Manager") {
            const updatedState = {
                ...state,
                isRM: false,
                isReportingManager: true,
                relationalManager2: null
            };

            await setState(updatedState);
            await updateAllManagerData(updatedState.isRM, updatedState.relationalManager2, updatedState.isReportingManager)
            props.listStaff({ history: props.history, searchText: state.searchText, page: 1, perPage: 50 })
            await getList_Manager()
        } else {
            // Unselected
            const updatedState = {
                ...state,
                isRM: false,
                isReportingManager: false,
                relationalManager2: null
            };
            await setState(updatedState);
            await updateAllManagerData(updatedState.isRM, updatedState.relationalManager2, updatedState.isReportingManager)
            props.listStaff({ history: props.history, searchText: state.searchText, page: 1, perPage: 50 })
            await getList_Manager()
        }
    };      

    const getList_Manager = async () => {
        let data = {}
        await axios.post(`${AppConfig.baseUrl}seller/getStaffListForRepManager`, data, {
            headers: {
                'Content-Type': 'application/json',
                'token': localStorage.getItem('admin_token')
            },
        }).then(result => {
            setManagerListed(result.data.detail)
        })
    }

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            name: props.selectedData ? props.selectedData.first_name : state.name,
            email: props.selectedData ? props.selectedData.email : state.email,
            phone: props.selectedData ? props.selectedData.phone : state.phone,
            staffId: props.selectedData ? props.selectedData._id : state.staffId,
            groupId: props.selectedData ? props.selectedData.Groups._id : state.groupId,
            permission: props.selectedData ? props.selectedData.Groups.permissions : state.permission,
            relationalManager2: props.selectedData ? props.selectedData.reporting_manager && props.selectedData.reporting_manager._id : state.relationalManager2
        }));
    }, [props.selectedData])

    const fetchApi = async () => {
        props.listPermissionModules({ history: props.history })
        let groupListData = await Axios.axiosHelperFunc('get', 'seller/getGroupList', '', {});
        setState((prev) => ({
            ...prev,
            name: props.selectedData ? props.selectedData.first_name : state.name,
            email: props.selectedData ? props.selectedData.email : state.email,
            phone: props.selectedData ? props.selectedData.phone : state.phone,
            staffId: props.selectedData ? props.selectedData._id : state.staffId,
            isRM: props.selectedData && props.selectedData.isRM,
            isReportingManager: props.selectedData && props.selectedData.isReportingManager,
            groupId: props.selectedData ? props.selectedData.Groups._id : state.groupId,
            isAllPermission: props.selectedData ? (props.selectedData.Groups.permissions.length === props.listpermissionModulesdata.length) ? true : false : false,
            permission: props.selectedData ? props.selectedData.Groups.permissions : state.permission,
            groups: groupListData.data.detail
        }));
    }

    useEffect(() => {
        fetchApi()
        getList_Manager()
    }, [])

    const handleClick = (key) => {
        setState((prev) => ({
            ...prev, [key]: !state[key]
        }));
    }

    const handleAddGroupClick = (key) => {
        props.handleClick('add')
        setState((prev) => ({
            ...prev, [key]: !state[key]
        }));
    }

    const handleRequestClose = () => {
        props.handleClick('edit');
        setState((prev) => ({
            ...prev, permission: [], email: '', name: '', phone: '', groupId: ''
        }));
        props.listStaff({ history: props.history, searchText: state.searchText, page: 1, perPage: 50 })
    };

    const handleChange = (event, key) => {
        if (key === 'group') {
            let index = state.groups.findIndex((e) => e._id === event.target.value);

            if (index > -1) {
                let tempPermission = state.permission;
                tempPermission = state.groups[index].permissions;

                let isAdminAccess = tempPermission.length === props.listpermissionModulesdata.length ? true : false;
                setState((prev) => ({
                    ...prev, permission: tempPermission,
                    groupId: event.target.value, isAllPermission: isAdminAccess
                }));
            } else {
                setState((prev) => ({ ...prev, groupId: '' }));
            }
        } else {
            setState((prev) => ({ ...prev, [key]: event.target.value }));
        }
    }

    const onSubmit = (values) => {
        let data = {
            first_name: values.name,
            email: values.email,
            phone: values.phone,
            groupId: values.groupId,
            staffId: state.staffId,
            isAllPermission: state.isAllPermission
        }
        props.handleClick('edit')
        props.addStaff({ history: props.history, data, listStaff: { searchText: '', page: 1, perPage: 50 } })
        setState((prev) => ({ ...prev, permission: [], email: '', name: '', phone: '', groupId: '' }));
    }

    const { email, name, groups, phone, permission, groupId, staffId } = state;
    const { edit, add, title, handleSubmit, listpermissionModulesdata, submitting } = props;

    return (
        <React.Fragment>
            <Dialog open={edit} onClose={handleRequestClose}
                fullWidth={true}
                maxWidth={'md'}>
                <Form
                    onSubmit={onSubmit}
                    initialValues={
                        {
                            name: name || '',
                            email: email || '',
                            phone: phone || '',
                            groupId: groupId || ''
                        }
                    }
                    render={({ handleSubmit, values }) => (
                        <form noValidate onSubmit={handleSubmit} autoComplete="off">
                            {props.loading === true ?
                                <div className="loader-view"
                                    style={{ height: props.width >= 1200 ? 'calc(100vh - 259px)' : 'calc(100vh - 238px)' }}>
                                    <CircularProgress />
                                </div> :
                                <>
                                    {/* <DialogTitle>
                                        {title}
                                            {
                                                //
                                                // <span>
                                                //     <span className='status'
                                                //         style={{ marginLeft: '40%', fontWeight: 600, fontSize: '15px', textAlignLast: 'right' }}
                                                //     > RM
                                                //         <Switch
                                                //             color='primary'
                                                //             checked={state.isRM}
                                                //             onChange={(e) => handleRMToggle(e)}
                                                //             aria-label="isRM"
                                                //             className="codToggle"
                                                //         />
                                                //     </span>
                                                //     <span className='status'
                                                //         style={{ fontWeight: 600, fontSize: '15px', textAlignLast: 'right' }}
                                                //     > Reporting Manager
                                                //         <Switch
                                                //             color='primary'
                                                //             checked={state.isReportingManager}
                                                //             onChange={(e) => handleRepoManagerToggle(e)}
                                                //             aria-label="isReportingManager"
                                                //             className="codToggle"
                                                //         />
                                                //     </span>
                                                // </span>
                                            }
                                    </DialogTitle> */}
                                    <DialogTitle>
                                        <div
                                            className="d-flex flex-wrap justify-content-between align-items-center"
                                            style={{ gap: "10px" }}
                                        >
                                            <span style={{ fontWeight: 600, fontSize: "20px" }}>{title}</span>

                                            <div className="d-flex flex-wrap align-items-center">
                                                <span
                                                    style={{
                                                        fontWeight: 600,
                                                        fontSize: "20px",
                                                        marginRight: "8px",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    Manager:
                                                </span>

                                                <FormGroup style={{ marginBottom: 0, minWidth: "200px", marginTop: "20px" }}>
                                                    <Input
                                                        name="orderStatus"
                                                        label="Status"
                                                        id="orderStatus"
                                                        value={
                                                            state.isRM
                                                                ? "Relational Manager"
                                                                : state.isReportingManager
                                                                    ? "Reporting Manager"
                                                                    : ""
                                                          }
                                                        type="select"
                                                        onChange={(event) => handleChange1(event, "rMId1")}
                                                    >
                                                        <option value="">Select Manager</option>
                                                        <option value="Relational Manager">Relational Manager</option>
                                                        <option value="Reporting Manager">Reporting Manager</option>
                                                    </Input>
                                                </FormGroup>
                                            </div>
                                        </div>
                                    </DialogTitle>

                                    <DialogContent>
                                        <DialogContentText>
                                        </DialogContentText>
                                        <Row>
                                            <Col xs={12} md={12} sm={12} xl={2} lg={2} className="addStaffAvatar">
                                                <Avatar className="size-100" alt="Remy Sharp" src={require('assets/productImage/avatar.png')} />
                                            </Col>
                                            <Col xs={12} md={12} sm={12} xl={10} lg={10}>
                                                <Row>
                                                    <Col xs={12} md={12} sm={12} xl={6} lg={6}>
                                                        <Field id="name" name="name" type="text"
                                                            component={ReactStrapTextField} label="Name"
                                                            validate={required}
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={12} sm={12} xl={6} lg={6}>
                                                        <Field id="email" name="email" type="text"
                                                            component={ReactStrapTextField} label="Email ID"
                                                            validate={emailField}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} md={12} sm={12} xl={6} lg={6}>
                                                        <Field id="phone" name="phone" type="text"
                                                            component={ReactStrapTextField} label="Phone"
                                                            validate={validatePhone}
                                                        />
                                                    </Col>
                                                    <Col xs={12} md={12} sm={12} xl={6} lg={6}>
                                                        <Row>
                                                            {

                                                            }
                                                            <Col xs={12} md={12} sm={12} xl={12} lg={12}>
                                                                <Field
                                                                    name="groupId"
                                                                    component={ReactstrapSelectField}
                                                                    label="Group"
                                                                    defaultValue={groupId}
                                                                    id='groupId'
                                                                    type="select"
                                                                    onChange={(event) => handleChange(event, 'group')}
                                                                >
                                                                    {
                                                                        state.groups && state.groups.length > 0 && state.groups.map((value, key) => {
                                                                            return <option key={'group_' + key} value={value._id}>{value.name}</option>
                                                                        })
                                                                    }
                                                                </Field>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                {
                                                    groupId !== '' ? <Row>
                                                        {
                                                            listpermissionModulesdata !== undefined && listpermissionModulesdata.length === permission.length ? <Col xs={6} md={6} sm={6} xl={6} lg={6}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={listpermissionModulesdata !== undefined && listpermissionModulesdata.length === permission.length}
                                                                            value={'admin_access'}
                                                                            color="primary"
                                                                            disabled={true}
                                                                        />
                                                                    }
                                                                    label={'Admin Access'}
                                                                />
                                                            </Col> : ''
                                                        }
                                                        {
                                                            (listpermissionModulesdata !== undefined && listpermissionModulesdata.length > 0) ? listpermissionModulesdata.map((value, key) => {
                                                                let index;

                                                                if (staffId !== '') {
                                                                    if (typeof (permission[0]) === 'string') {
                                                                        index = permission.findIndex((e) => e === value._id)
                                                                    } else {
                                                                        index = permission.findIndex((e) => e._id === value._id)
                                                                    }
                                                                } else {
                                                                    index = permission.findIndex((e) => e._id === value._id)
                                                                }

                                                                return index > -1 ? <Col xs={6} md={6} sm={6} xl={6} lg={6}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={index > -1 ? true : false}
                                                                                value={value.value}
                                                                                color="primary"
                                                                                disabled={true}
                                                                            />
                                                                        }
                                                                        label={value.name}
                                                                    />
                                                                </Col> : ''
                                                            }) : ''
                                                        }
                                                    </Row> : ''
                                                }
                                            </Col>
                                        </Row>
                                    </DialogContent>
                                    <DialogActions className="pr-4">
                                        <Button onClick={handleRequestClose} color='secondary' >
                                            Cancel
                                        </Button>
                                        <Button type='submit' color='primary' disabled={submitting}>
                                            Edit
                                        </Button>
                                    </DialogActions>
                                </>
                            }
                        </form>
                    )}
                />
                <Dialog open={state.configPopup} onClose={handleClosePopup} fullWidth={true} maxWidth={'sm'}>
                            <DialogTitle>
                              Select Reporting Manager
                            </DialogTitle>
                            <DialogContent className='pt-0'>
                              <Row style={{ marginTop: '10px' }}>
                                <Col xs='5'>
                                  <span
                                    style={{ fontWeight: 600, fontSize: '20px', textAlignLast: 'right' }}
                                  >Reporting&nbsp;Manager&nbsp;:</span>
                                </Col>
                                <Col xs='6' >
                                  <FormGroup style={{ textAlignLast: 'left' }} >
                                    <Input
                                      name="orderStatus"
                                      label="Status" id="orderStatus"
                                      value={state.relationalManager2}
                                      type="select"
                                      onChange={(event) => handleChangeManager(event)}
                                    >
                                      <option value="">Select Manager</option>
                                      {/* {managerListed && managerListed.map((val, i) => {
                                        return <option key={i} value={val._id}>{val.first_name
                                        }</option>
                                      })} */}
                                        {managerListed && managerListed.map((val, i) => {
                                            if (val._id === props.selectedData._id) return null; // skip this one
                                            return (
                                                <option key={i} value={val._id}>
                                                    {val.first_name}
                                                </option>
                                            );
                                        })}
                                    </Input>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={handleClosePopup} color='secondary' >
                                Close
                              </Button>
                            </DialogActions>
                </Dialog>
            </Dialog>
            {
                props.permission && props.permission.length > 0 ? <AddGroup add_group={state.addGroup} permission={props.permission} title={'Add Group'} handleClick={handleClick} /> : ''
            }
        </React.Fragment>
    );
}

const mapStateToProps = ({ admin }) => {
    const { listGroupData, listpermissionModulesdata, loading } = admin;
    return { listGroupData, listpermissionModulesdata, loading }
};

export default connect(
    mapStateToProps,
    {
        listGroup,
        listPermissionModules,
        addStaff,
        listStaff
    }               // bind account loading action creator
)(EditStaff) 